import Dialog from '../dialog';
import './styles.scss';
import { ReactComponent as StatusWarningIcon } from '../../../assets/icons/status-warning.svg';
import { ReactComponent as StatusSuccessIcon } from '../../../assets/icons/status-success.svg';

interface CardTitleProps {
  status: 'success' | 'warning';
  children: JSX.Element;
  handleClose: () => void;
}

const DialogStatus = ({ status, children, handleClose }: CardTitleProps) => (
  <Dialog
    dividers={false}
    unpaddingContent
    unpaddingFooter
    handleClose={handleClose}
    type="sm"
    body={
      <div className="dialog-status">
        <div>
          {status === 'warning' && <StatusWarningIcon />}
          {status === 'success' && <StatusSuccessIcon />}
        </div>
        <div className="dialog-status__message">{children}</div>
        <div
          className={`${
            status === 'success' ? 'dialog-status__success-line' : status === 'warning' ? 'dialog-status__warning-line' : ''
          }`}
        />
      </div>
    }
  />
);

export default DialogStatus;
